import React from "react"
import badge from "badges/diving-into-methods.svg"
import { BadgeImage } from "backpack/badges/styled"

const DivingIntoMethods = props => <BadgeImage src={badge} {...props} />

export default DivingIntoMethods
